import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, holdItemShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import Checkbox from '@bibliocommons/base-checkbox';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';

import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import { SHELF_NAMES } from 'app/constants/ShelfConstants';
import accountShape from 'app/shapes/accountShape';

import './CancelHoldForm.scss';

export default class CancelHoldForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      addToShelf: false
    };

    bindAll(this);
  }

  handleShelfChange(addToShelf) {
    this.setState({ addToShelf });
  }

  handleCancelHold() {
    const { bib, holdItem, currentAccount, handleClose, holdActions, shelfActions } = this.props;

    holdActions.cancelHold({
      accountId: currentAccount.get('id'),
      metadataIds: [bib.get('id')],
      holdIds: [holdItem.get('holdsId')],
      postSuccess: () => {
        if (this.state.addToShelf) {
          shelfActions.addToShelf({
            metadataId: bib.get('id'),
            shelfToAdd: SHELF_NAMES.FOR_LATER,
            postSuccess: handleClose
          });
        } else {
          handleClose();
        }
      }
    });
  }

  renderShelfCheckbox() {
    return (
      <div>
        <p>
          <FormattedMessage id="keep_a_reference" tagName="strong" />
        </p>
        <Checkbox
          id="add-to-shelf-checkbox"
          dataKey="add-to-shelf-checkbox"
          label={<FormattedMessage id="add_title_to_for_later_shelf" />}
          checked={this.state.addToShelf}
          handleChange={this.handleShelfChange}
        />
      </div>
    );
  }

  render() {
    const { bib, shelfTransactions, holdItem, holdsTransactions } = this.props;
    const isCancelling = holdsTransactions.getIn([holdItem.get('holdsId'), 'isCancelling'], false);
    const isAddingToShelf = shelfTransactions.getIn([bib.get('id'), 'isAdding'], false);

    return (
      <div className="cp-cancel-hold-form">
        <ModalHeader title={<FormattedMessage id="cancel_hold" />} />
        <ModalContent>
          <BibBriefContainer metadataId={bib.get('id')} />
          <p className="cancel-hold-description">
            <FormattedMessage id="cancel_hold_description" />
          </p>
          {this.renderShelfCheckbox()}
        </ModalContent>
        <ModalFooter
          primaryActionButtonTag={TransactionalSolidButton}
          primaryActionButtonText={<FormattedMessage id="cancel_hold" />}
          handlePrimaryAction={this.handleCancelHold}
          isLoading={isCancelling || isAddingToShelf}
        />
      </div>
    );
  }
}

CancelHoldForm.propTypes = {
  bib: bibShape.isRequired,
  holdItem: holdItemShape.isRequired,
  currentAccount: accountShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};
